import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreditCard } from '../../models/domain/credit.card';
import { CreditCardEditRequest } from '../../models/ss-api/requests/credit.card.edit.request';
import { Router } from '@angular/router';

export interface IEditCreditCardDialogModel {
    creditCard: CreditCard;
}

@Component({
    selector: 'edit-credit-card-dialog',
    styleUrls: ['./edit.credit.card.dialog.css'],
    templateUrl: './edit.credit.card.dialog.html'
})
export class EditCreditCardDialog extends DialogComponent<IEditCreditCardDialogModel, boolean> implements IEditCreditCardDialogModel, OnInit {

    creditCard: CreditCard;

    newExpMonth: number = new Date().getMonth();
    newExpYear: number = new Date().getFullYear();

    CreditCardForm: FormGroup;

    Year: number = new Date().getFullYear();
    YearRange: any[] = [];

    // dialog confirm add creditcard
    Add_Confirm_Title: string = 'Update Credit Card?';
    Add_Confirm_Text: string = 'You are about to change the expiration date on this Credit Card.';

    // dialog added info
    Add_Added_Title: string = 'Success!';
    Add_Added_Text: string = 'Credit Card updated.';
    Add_Added_Timeout: number = 1500;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

        this.CreditCardForm = new FormGroup({
            // 'ccNameOnCard': new FormControl("", [Validators.required]),
            // 'ccNr': new FormControl("", [Validators.required, Validators.maxLength(22), Validators.minLength(13), Validators.pattern('^[0-9 \+\-\]+$')]),
            'ccExpMonth': new FormControl('01', [Validators.required]),
            'ccExpYear': new FormControl(this.Year, [Validators.required]),
            'ccFirstName': new FormControl(this.creditCard.FirstName, [Validators.required]),
            'ccLastName': new FormControl(this.creditCard.LastName, [Validators.required]),
            // 'ccMakeDefault': new FormControl(true),
            // 'address1': new FormControl("", [Validators.required, Validators.minLength(5)]),
            // 'city': new FormControl("", [Validators.required, Validators.minLength(3)]),
            // 'state': new FormControl("", [Validators.required, Validators.minLength(2)]),
            'zipCode': new FormControl("", [Validators.required, Validators.minLength(3)]),
            // 'country': new FormControl("US", [Validators.required]),
        })

        // SET UP YEAR DROPDOWN
        for (let i: number = 0; i < 21; i++) {
            this.YearRange.push(this.Year + i);
        }

        this.newExpMonth = this.creditCard.ExpMonth;
        this.newExpYear = this.creditCard.ExpYear + 2000;
    }

    confirm() {

        let expMonth = this.CreditCardForm.controls.ccExpMonth.value;
        let expYear = this.CreditCardForm.controls.ccExpYear.value;
        let firstName = this.CreditCardForm.controls.ccFirstName.value;
        let lastName = this.CreditCardForm.controls.ccLastName.value;
        let zipCode = this.CreditCardForm.controls.zipCode.value;

        // MAKE SURE CARD ISN"T EXPIRED
        let currentYear = new Date().getFullYear();
        let currentMonth = new Date().getMonth();
        if (expYear < currentYear || (expYear == currentYear && expMonth < currentMonth)) {
            this.sweetAlertService.swal({
                title: 'This Card Has Expired!',
                text: 'Make sure to provide a credit card with a valid expiration date',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
                .then(() => { }, () => { }); // keep this line to prevent promise error;
            return;
        }

        let request = new CreditCardEditRequest;

        request.CreditCardID = this.creditCard.ID;
        request.ExpMonth = this.newExpMonth;
        request.ExpYear = this.newExpYear;
        request.FirstName = firstName;
        request.LastName = lastName;
        request.Zipcode = zipCode;
        // confirm
        this.sweetAlertService.swal({
            title: this.Add_Confirm_Title,
            text: this.Add_Confirm_Text,
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.api.EditCreditCard(request).toPromise()
            }
        }).then(
            async (response) => {

                console.log(response);
                
                if (!response.Result) {

                    var title = "Error";
                    var message = "Error updating credit card";

                    if (response.Data.includes("AVS")){
                        title = "Zip Code Error";
                        message = "Wrong Zip Code for this card.";
                    }
                    else if (response.Data.includes("CVC")){
                        title = "CVC Error";
                        message = "Wrong CVC Security code for this card.";
                    }

                    // error
                    this.sweetAlertService.swal(
                        {
                            title: title,
                            text: message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: this.Add_Added_Timeout
                        })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                    return;
                }

                // show confirmation
                this.sweetAlertService.swal(
                    {
                        title: this.Add_Added_Title,
                        text: this.Add_Added_Text,
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: this.Add_Added_Timeout
                    })
                    .then(() => {

                    }, () => { }); // keep this line to prevent promise error;

                this.close();
            },
            (dismiss) => {
                if (dismiss === 'cancel') {

                    if (!confirm)
                        return;

                    // show cancelled
                    this.sweetAlertService.swal({
                        title: 'Cancelled',
                        text: 'No changes are saved.',
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1000
                    }).then(() => {
                        this.close();
                    }, () => { }); // keep this line to prevent promise error;
                }
            }).catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        // this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        // this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

}
